/**
 * Sentinel `selectedInstagramId` value the picker writes when there is
 * no Page→IG bond at all (neither `instagram_business_account` nor
 * `connected_instagram_account`). The launcher reads this and strips
 * the IG identity from the ad creative entirely, so Meta delivers to
 * Instagram surfaces using the Facebook Page's identity (Page name +
 * profile picture) instead of falling back to whichever BM-owned IG
 * `resolveInstagramIdentity` happens to surface.
 *
 * Source of truth — frontend pickers (v1 + v2) and backend resolvers
 * must compare against this constant rather than redeclaring the
 * string locally.
 */
export const NO_INSTAGRAM_SENTINEL = "NO_INSTAGRAM" as const;
export type NoInstagramSentinel = typeof NO_INSTAGRAM_SENTINEL;
